import type {
  CreateOAuthClientPayload,
  OAuthClient,
  UpdateOAuthClientPayload,
} from 'src/interfaces/oauth'
import { resolveSubmittedScopes } from 'src/utils/oauthClient'
import type { OAuthClientFormValues } from './OAuthClientForm.interface'

/** Copies the array so Formik never edits the object held in the Redux store. */
export function toFormValues(client: OAuthClient | null): OAuthClientFormValues {
  if (client === null) {
    return { scopes: [] }
  }

  return { scopes: [...client.scopes] }
}

export function toCreatePayload(
  partnerId: string,
  values: OAuthClientFormValues,
): CreateOAuthClientPayload {
  return {
    partnerId,
    scopes: values.scopes,
  }
}

/**
 * `deactivate` is deliberately absent: this is the scopes-only save, and the backend leaves
 * `deactivatedAt` untouched when the key is omitted. Enabling and disabling go through the
 * status bar, which builds its own payload from the persisted scopes.
 */
export function toUpdatePayload(
  partnerId: string,
  values: OAuthClientFormValues,
  client: OAuthClient,
): UpdateOAuthClientPayload {
  return {
    partnerId,
    scopes: resolveSubmittedScopes(values.scopes, client.scopes),
  }
}
